import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-button p-text-bold", 
      _ctx.isActive ? 'border-bottom-active' : 'border-bottom'
    ])
  }, _toDisplayString(_ctx.displayText), 3))
}